import { render } from "./SurveyImprovement.vue?vue&type=template&id=b0661bb0&scoped=true"
import script from "./SurveyImprovement.vue?vue&type=script&lang=js"
export * from "./SurveyImprovement.vue?vue&type=script&lang=js"

import "./SurveyImprovement.vue?vue&type=style&index=0&id=b0661bb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0661bb0"]])

export default __exports__